import { getUrl } from '@publicss/utils';
import { Script } from 'gatsby';
import React from 'react';

import { getCompressedUrl } from '../../utils/getCompressedUrl';

type ScriptsProps = {
  siteTag?: string;
  siteLang?: string;
};

const EmeaScripts: React.FC<ScriptsProps> = ({ siteTag, siteLang }) => {
  const compressedUrl = getCompressedUrl();

  const isBookitEnabled = [
    'site:citychefs',
    'site:cookcity',
    'site:cooklane',
    'site:dishmix',
    'site:foodstars',
    'site:kitchenpark',
    'site:pedidoslab',
  ].includes(siteTag ?? '');

  const isThankYouPage = getUrl().includes('/thank-you/');

  const isKitchenPark = siteTag === 'site:kitchenpark';

  const watiCtaText =
    siteLang === 'en-ae' ? 'Chat with us' : 'تواصل معنا عبر الدردشة';
  const watiWelcomeText =
    siteLang === 'en-ae'
      ? 'Hi there! How can I help you?'
      : ' مرحبًا! كيف يمكنني مساعدتك؟';
  const watiMessageText =
    siteLang === 'en-ae'
      ? 'Hello, I have a question about'
      : 'مرحبًا، لدي استفسار بخصوص';

  return (
    <>
      <script src="https://cdn.polygraph.net/pg.js" />
      {isBookitEnabled && isThankYouPage && (
        <Script>{`
            var _ld_scriptEl = document.createElement('script');
            _ld_scriptEl.src = 'https://cdn.leandata.com/js-snippet/ld-book-v2.js';
            _ld_scriptEl.addEventListener('load', function () {
              LDBookItV2.initialize('00Df4000003jvM8EAI', 'New Prospect', 'ld_bookit_log_id');
              LDBookItV2.setFormProvider('typeform');
              if (LDBookItV2.validateTempUID()) {
                LDBookItV2.saveFormDataFromURLParams();
                LDBookItV2.submit();
              }
            });
            document.body.appendChild(_ld_scriptEl);
          `}</Script>
      )}
      {isBookitEnabled && !isThankYouPage && (
        <Script>{`
            var orgId = '00Df4000003jvM8EAI';
            var hiddenFieldName = 'ld_bookit_log_id';
            (function (orgId, hiddenFieldName) {
              let hiddenUID = ''+orgId+'_'+Date.now()+'_'+Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
              let forms = document.querySelectorAll('[ld-name="typeform"]');
              for (const form of forms) {
                form.setAttribute('data-tf-hidden', hiddenFieldName+'='+hiddenUID);
              }
              window.localStorage.setItem('LDBookItV2_tempSavedUID', hiddenUID);
            })(orgId, hiddenFieldName);
        `}</Script>
      )}
      {isKitchenPark && (
        <Script
          strategy="post-hydrate"
          async
          src="https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?24781"
          type="text/javascript"
          onLoad={() => {
            (window as any).CreateWhatsappChatWidget({
              enabled: true,
              chatButtonSetting: {
                backgroundColor: '#008078',
                ctaText: `${watiCtaText}`,
                borderRadius: '25',
                marginLeft: '0',
                marginRight: '20',
                marginBottom: '20',
                ctaIconWATI: false,
                position: 'right',
              },
              brandSetting: {
                brandName: 'KitchenPark',
                brandSubTitle: 'undefined',
                brandImg:
                  'https://www.wati.io/wp-content/uploads/2023/04/Wati-logo.svg',
                welcomeText: `${watiWelcomeText}`,
                messageText: `${watiMessageText} ${compressedUrl}`,
                backgroundColor: '#00e785',
                ctaText: `${watiCtaText}`,
                borderRadius: '25',
                autoShow: false,
                phoneNumber: '971556683138',
              },
            });
          }}
        />
      )}
      <Script>{`
        setTimeout(function() {
          function getLatestDataLayerValue(param) {
            if (!window.dataLayer || !Array.isArray(window.dataLayer)) return null;
            for (let i = window.dataLayer.length - 1; i >= 0; i--) {
              let entry = window.dataLayer[i];
              if (entry && typeof entry === 'object' && entry[param] !== undefined) {
                return entry[param];
              }
            }
            return null;
          }
          const container = document.querySelector('div[data-testid="tf-v1-popup"]');
          if (!container) return;
          let existingHidden = container.getAttribute('data-tf-hidden') || '';
          let params = new URLSearchParams(existingHidden);
          const firstTouchParams = [
            'original_utm_source',
            'original_utm_medium',
            'original_utm_campaign',
            'original_utm_term',
            'original_utm_content',
            'original_utm_id'
          ];
          const lastTouchParams = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_term',
            'utm_content',
            'utm_id'
          ];
          firstTouchParams.forEach(param => {
            if (!params.has(param)) {
              let value = getLatestDataLayerValue(param);
              if (value) {
                params.set(param, value);
              }
            }
          });
          lastTouchParams.forEach(param => {
            let value = getLatestDataLayerValue(param);
            if (value) {
              params.set(param, value);
            }
          });
          container.setAttribute('data-tf-hidden', params.toString());
        }, 500);
      `}</Script>
    </>
  );
};

export default EmeaScripts;
